import {createSelector} from "@ngrx/store";
import {ICurationState} from "../../../../curation/store/curation.reducer";
import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface";


export const selectPreviewDataFeature = (state: ICurationState) => state;
export const selectState = (state: IgenomicsState) => state;

export const getPreviewPatient = createSelector(selectPreviewDataFeature,
  (state) => state.previewData.patient);

export const getPreviewTestConfiguration = createSelector(selectPreviewDataFeature,
  (state) => state.previewData.testConfiguration);


export const getPreviewStatus = createSelector(selectState,
  (state) => state.curation.previewData.previewStatus);

